import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MapPin, Phone, Mail, Globe, Calendar } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div className="App">
      <Header />
      <section className="bg-navy text-white py-16" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-widest text-magenta">Contact</span>
          <h1 className="mt-3 font-display text-4xl lg:text-5xl font-black">We're here to help you move forward.</h1>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10">
          <div className="bg-soft-gray rounded-lg p-8 border border-navy/10">
            <h2 className="font-display text-2xl font-bold text-navy mb-6">African American Women Trucking Association</h2>
            <ul className="space-y-5 text-dark-text/85">
              <li className="flex items-start gap-3"><MapPin className="text-magenta mt-0.5 shrink-0" /> 5269 Buford Highway Suite 213, Buford, GA 30340</li>
              <li className="flex items-center gap-3"><Phone className="text-magenta shrink-0" /> <a href="tel:7707566768" className="hover:text-magenta font-semibold">770-756-6768</a></li>
              <li className="flex items-center gap-3"><Mail className="text-magenta shrink-0" /> <a href="mailto:contact@aawta.org" className="hover:text-magenta font-semibold">contact@aawta.org</a></li>
              <li className="flex items-center gap-3"><Globe className="text-magenta shrink-0" /> <a href="https://www.aawta.org" target="_blank" rel="noopener noreferrer" className="hover:text-magenta font-semibold">www.aawta.org</a></li>
            </ul>
          </div>

          <div>
            <h2 className="font-display text-2xl font-bold text-navy">Have additional questions?</h2>
            <p className="mt-3 text-dark-text/80 leading-relaxed">
              Email <a href="mailto:contact@aawta.org?subject=Driven%20Together%20Education%20Program" className="text-magenta font-semibold">contact@aawta.org</a> and
              use the subject line: <strong>Driven Together Education Program</strong>.
            </p>
            <div className="mt-8 space-y-3">
              <Link to="/intake" data-testid="contact-start-intake" className="w-full inline-flex items-center justify-center gap-2 bg-magenta hover:bg-magenta-dark text-white font-bold py-3.5 px-6 rounded-md transition-colors">
                Start Your Intake
              </Link>
              <a href="https://aawta-hub.emergent.host/book/aawta" target="_blank" rel="noopener noreferrer"
                 data-testid="contact-schedule"
                 className="w-full inline-flex items-center justify-center gap-2 border-2 border-navy text-navy hover:bg-navy-light font-bold py-3.5 px-6 rounded-md transition-colors">
                <Calendar size={18} /> Schedule an Appointment
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
